import StandTableFilter from "./stand-table-filter";

const StandFilters = {
  Table: StandTableFilter,
};

export default StandFilters;
